/**
 * Admin layout page mounted at "/admin/*" in App.tsx (behind ProtectedRoute with
 * requiresLogin + requiresAdmin). Renders the admin Sidebar (ai admin, bounty admin,
 * user admin sections) alongside nested Routes for the six admin pages:
 * /admin/bounties, /admin/submissions, /admin/submission-verification,
 * /admin/search, /admin/users, and /admin/comms.
 */
import React from "react";
import { Routes, Route } from "react-router-dom";
import { Sidebar, SidebarSection } from "@/components/Sidebar";
import SubmissionVerificationPage from "@/pages/admin/ai/SubmissionVerification/SubmissionVerificationAdminPage";
import SearchAdminPage from "@/pages/admin/ai/Search/SearchAdminPage";
import SubmissionsAdminPage from "@/pages/admin/bounties/SubmissionsAdminPage";
import BountiesAdminPage from "@/pages/admin/bounties/BountiesAdminPage";
import UsersAdminPage from "@/pages/admin/users/UsersAdminPage";
import CommsAdminPage from "@/pages/admin/users/CommsAdminPage";

export const AdminHomepage: React.FC = () => {
    const sidebarSections: SidebarSection[] = [
        {
            title: "ai admin",
            items: [
                { label: "submission verification", url: "/admin/submission-verification" },
                { label: "search", url: "/admin/search" },
            ],
        },
        {
            title: "bounty admin",
            items: [
                { label: "bounties", url: "/admin/bounties" },
                { label: "submissions", url: "/admin/submissions" },
            ],
        },
        {
            title: "user admin",
            items: [
                { label: "users", url: "/admin/users" },
                { label: "comms", url: "/admin/comms" },
            ],
        },
    ];

    return (
        <div className="bg-slate-50 h-full w-full flex text-black font-porsui relative">
            <Sidebar sections={sidebarSections} />

            <div className="flex-1 overflow-auto ml-0 md:ml-2 relative z-10">
                <Routes>
                    <Route path="bounties" element={<BountiesAdminPage />} />
                    <Route path="submissions" element={<SubmissionsAdminPage />} />
                    <Route
                        path="submission-verification"
                        element={<SubmissionVerificationPage />}
                    />
                    <Route path="search" element={<SearchAdminPage />} />
                    <Route path="users" element={<UsersAdminPage />} />
                    <Route path="comms" element={<CommsAdminPage />} />
                </Routes>
            </div>
        </div>
    );
};
